module.exports = "https://99designs-start-assets.imgix.net/js/b1ba12cfacee113a6441596fe1273716.jpg";